
import { Component, Vue, VModel } from 'vue-property-decorator';
import {
    CategoryCustomFieldGroupModel,
    CategoryCustomFieldModel,
    CustomFieldTypeEnum,
    CustomFieldGroupTypeEnum,
} from '@/libs/Api';

@Component
export default class CategoryCustomFieldGroupList extends Vue {
    @VModel({ type: Array, required: true }) groups!: CategoryCustomFieldGroupModel[];

    CustomFieldGroupTypeEnum = CustomFieldGroupTypeEnum;

    get fieldTypeOptions() {
        return [
            { value: CustomFieldTypeEnum.String, text: this.$t('categories.customFields.typeString') },
            { value: CustomFieldTypeEnum.Integer, text: this.$t('categories.customFields.typeInteger') },
            { value: CustomFieldTypeEnum.Double, text: this.$t('categories.customFields.typeDouble') },
            { value: CustomFieldTypeEnum.Date, text: this.$t('categories.customFields.typeDate') },
            { value: CustomFieldTypeEnum.DateTime, text: this.$t('categories.customFields.typeDateTime') },
            { value: CustomFieldTypeEnum.Boolean, text: this.$t('categories.customFields.typeBoolean') },
            { value: CustomFieldTypeEnum.TextArea, text: this.$t('categories.customFields.typeTextArea') },
        ];
    }

    get groupTypeOptions() {
        return [
            { value: 'General', text: this.$t('categories.customFields.groupTypeGeneral') },
            { value: 'Process', text: this.$t('categories.customFields.groupTypeProcess') },
            { value: 'Other', text: this.$t('categories.customFields.groupTypeOther') },
        ];
    }

    updateModelValue(val: CategoryCustomFieldGroupModel[]) {
        return val;
    }

    addGroup() {
        const maxPosition = (this.groups || []).reduce(
            (max, g) => (typeof g.position === 'number' && g.position > max ? g.position : max),
            0
        );
        const newGroup: CategoryCustomFieldGroupModel = {
            id: undefined,
            name: '',
            categoryCustomFields: [],
            categoryId: undefined,
            createdAt: undefined,
            createdById: undefined,
            tenantId: undefined,
            isDeleted: false,
            position: maxPosition + 1,
        };
        this.groups = [...(this.groups || []), newGroup];
    }

    addField(group: CategoryCustomFieldGroupModel) {
        const maxPosition = (group.categoryCustomFields || []).reduce(
            (max, f) => (typeof f.position === 'number' && f.position > max ? f.position : max),
            0
        );
        const newField: CategoryCustomFieldModel = {
            id: undefined,
            name: '',
            type: CustomFieldTypeEnum.String,
            title: '',
            placeholder: '',
            categoryCustomFieldGroupId: group.id,
            createdAt: undefined,
            createdById: undefined,
            tenantId: undefined,
            isDeleted: false,
            position: maxPosition + 1,
            isRequired: false,
        };
        group.categoryCustomFields = [...(group.categoryCustomFields || []), newField];
        // Trigger reactivity
        this.groups = [...(this.groups || [])];
    }

    removeField(group: CategoryCustomFieldGroupModel, fieldIdx: number) {
        if (!group.categoryCustomFields) return;
        group.categoryCustomFields.splice(fieldIdx, 1);
        // Trigger reactivity
        this.groups = [...(this.groups || [])];
    }

    removeGroup(groupIdx: number) {
        this.groups.splice(groupIdx, 1);
        this.groups = [...(this.groups || [])];
    }

    moveGroupUp(idx: number) {
        if (idx <= 0) return;
        const arr = [...this.groups];
        [arr[idx - 1], arr[idx]] = [arr[idx], arr[idx - 1]];
        // Aktualizace position podle nového pořadí
        arr.forEach((g, i) => {
            g.position = i + 1;
        });
        this.groups = arr;
    }

    moveGroupDown(idx: number) {
        if (idx >= this.groups.length - 1) return;
        const arr = [...this.groups];
        [arr[idx], arr[idx + 1]] = [arr[idx + 1], arr[idx]];
        arr.forEach((g, i) => {
            g.position = i + 1;
        });
        this.groups = arr;
    }

    moveFieldUp(group: CategoryCustomFieldGroupModel, idx: number) {
        if (!group.categoryCustomFields || idx <= 0) return;
        const arr = [...group.categoryCustomFields];
        [arr[idx - 1], arr[idx]] = [arr[idx], arr[idx - 1]];
        arr.forEach((f, i) => {
            f.position = i + 1;
        });
        group.categoryCustomFields = arr;
        this.groups = [...(this.groups || [])];
    }

    moveFieldDown(group: CategoryCustomFieldGroupModel, idx: number) {
        if (!group.categoryCustomFields || idx >= group.categoryCustomFields.length - 1) return;
        const arr = [...group.categoryCustomFields];
        [arr[idx], arr[idx + 1]] = [arr[idx + 1], arr[idx]];
        arr.forEach((f, i) => {
            f.position = i + 1;
        });
        group.categoryCustomFields = arr;
        this.groups = [...(this.groups || [])];
    }
}
